module.exports = __webpack_public_path__ + "static/altin-pakmaya-odul-b938219661522a43449a7970d38166d7.png";